import React, { useContext, useEffect, useState } from "react";
import useDocumentTitle from "../../components/helpers/useDocumentTitle";
import { useTranslation } from "react-i18next";
import InputField from "../../components/shared/InputField";
import Button from "../../components/shared/Button";
import { Link, useNavigate } from "react-router-dom";
import apiClient from "../../components/utils/apiClient";
import useToken from "../../components/helpers/useToken";
import useUser from "../../components/helpers/useUser";
import { OtpInput } from 'reactjs-otp-input';
import OTPInputField from "../../components/shared/OTPInputField";
import { UserContext } from "../../App";

const LoginPage = () => {

  const {i18n,t} = useTranslation();
  useDocumentTitle('pageTitles.login');
  const navigate = useNavigate();
  const [isFormSubmitDisabled,setIsFormSubmitDisabled] = useState(true);
  const [signInForm,setSignInForm] = useState({email:'', password: ''});
  const [errors, setErrors] = useState(null);
  const [showOTP, setShowOTP] = useState(false);
  const [token, setToken] = useToken();
  const [user, setUser] = useUser();
  const {setIsUserLoggedIn} = useContext(UserContext);

  useEffect(()=>{
    if(signInForm && signInForm?.email && signInForm?.password) {
      setIsFormSubmitDisabled(false);
    } else {
      setIsFormSubmitDisabled(true);
    }
  },[signInForm]);

  const hideError = (err) => {
    if(errors) {
      let errorsList = errors;
      delete errorsList[err];
      setErrors(errorsList);
    }
  }

  const handleClickSignInButton = () => {
    setErrors(null);
    let errorsList = {};
    // if(signInForm?.password?.length !== 4) {
    //   errorsList.password = 'validation.passwordLength';
    // }
    // if(!/^(5)([0-9]{8})$/.test(signInForm?.mobile?.replace('+966',''))) {
    //   errorsList.mobile = 'validation.invalidmobile';
    // }
    if(Object.keys(errorsList).length > 0) {
      setErrors(errorsList);
    } else {
      handleClickSignInButtonAction();
    }
  }



  const handleClickSignInButtonAction = async () => {
    setIsFormSubmitDisabled(true);
    try {
      const response = await apiClient.post(`/b-users/login`,Object.fromEntries(Object.entries(signInForm).filter(([_, v]) => v !== '')));
      if(response?.status === 200) {
        setToken(response?.data?.accessToken);
        const getUser = response?.data?.user;
        getUser.username = getUser.mobile.replace('+966','966');
        setIsUserLoggedIn(getUser);
        setUser(getUser);
      } else {
        setIsFormSubmitDisabled(false);
      }
    } catch(err) {
      setIsFormSubmitDisabled(false);
      if(err?.response?.data?.message) {
        let errorsList = {};
        errorsList.password = err?.response?.data?.message;
        setErrors(errorsList)
      } else {
        let errorsList = {};
        errorsList.OTP =err?.response?.data?.message;
        setErrors(errorsList);
      }
    }
  }

  useEffect(()=>{
    if(token && token !== undefined && token !== 'undefined' && token !== 'remove') {
      navigate(`/${i18n.language}/`);
    }
  },[token])


  // console.log(isFormSubmitDisabled);
  return (
    <div className="w-full">
      <h3 className="text-grey-900 font-[600] text-[32px] leading-[48px]">هلا بك في فني أعمال</h3>
      <p className="text-grey-600 font-[500] text-[18px] leading-[27px] mt-[15px] mb-[40px]">هنا يمكنك التحكم في إدارة و صيانة عقاراتك بكل سهولة و فعالية</p>
      <p className="text-grey-900 font-[500] text-[18px] leading-[27px]">الرجاء إدخال رقم الجوال أو البريد الإلكتروني المسجل</p>
      <div className="w-full max-w-[450px] pt-[40px]">
          <div className="mb-[20px]">
            <InputField label={'البريد الإلكتروني'} value={signInForm?.email} error={errors?.email} errorMessage={errors?.email} translateError={true} onChange={(e)=>{ if(e.target.value === '' || e.target.value) { setSignInForm({ ...signInForm, email: e.target.value }) }; hideError('email')}} />
          </div>
          <div className="mb-[20px] relative">
            <Link to={`/ar/forgot-password`} className="text-orange font-[500] text-[14px] absolute end-0 top-0 z-[5]">هل نسيت كلمة المرور؟</Link>
            <InputField type="password" label={'كلمة المرور'} value={signInForm?.password} error={errors?.password} errorMessage={errors?.password} translateError={true} onChange={(e)=>{ if(e.target.value === '' || e.target.value) { setSignInForm({ ...signInForm, password: e.target.value }) }; hideError('password')}} />
          </div>
          <div className="mb-[35px]">
            <Button type="button" text={t('forms.signin')} disabled={isFormSubmitDisabled} onClick={()=>handleClickSignInButton()} />
          </div>
        <p className="text-grey-600 text-[18px] font-[500] leading-[27px]">إذا كنت لا تمتلك حساب من فضلك قم  <Link className="text-blue font-[700]" to={process.env.REACT_APP_API_URL === 'https://beta-production-api.fanni.site' ? `https://business.fanni.sa/packages.html` : `https://staging-business.fanni.sa/packages.html`}>بإنشاء حساب جديد</Link>.</p>
      </div>
    </div>
  );
};

export default LoginPage;
